export type FilterAction =
  | { type: 'set-sort'; sort: string }
  | { type: 'set-filter'; key: number; value: number[] }
  | { type: 'set-brands'; value: number[] }
  | { type: 'set-collections'; value: number[] }
  | { type: 'reset-filter'; key: number }
  | { type: 'reset-brands' }
  | { type: 'reset-collections' }
  | { type: 'set-page'; page: number }
  | { type: 'set-filters'; filters: Filters }
  | { type: 'clear-filters' }

export type Filters = { [id: number]: number[] }

export type FilterState = {
  sort: string
  page: number
  filters: Filters
  brands: number[]
  collections: number[]
}

export function reducer(state: FilterState, action: FilterAction): FilterState {
  switch (action.type) {
    case 'set-sort':
      return {
        ...state,
        sort: action.sort,
      }
    case 'set-filter':
      return {
        ...state,
        page: 1,
        filters: {
          ...state.filters,
          [action.key]: action.value,
        },
      }
    case 'set-brands':
      return { ...state, page: 1, brands: action.value }
    case 'set-collections':
      return { ...state, page: 1, collections: action.value }
    case 'reset-filter':
      const newState = { ...state }
      delete newState.filters[action.key]
      return newState
    case 'reset-brands':
      return { ...state, brands: [] }
    case 'reset-collections':
      return { ...state, collections: [] }
    case 'set-filters':
      return {
        ...state,
        filters: action.filters,
      }
    case 'set-page':
      return { ...state, page: action.page }
    case 'clear-filters':
      return { ...state, brands: [], collections: [], filters: {}, page: 1 }
    default:
      return state
  }
}
